import { render, staticRenderFns } from "./HomeHorizontal.vue?vue&type=template&id=239c811e&scoped=true&lang=pug"
import script from "./HomeHorizontal.vue?vue&type=script&lang=ts"
export * from "./HomeHorizontal.vue?vue&type=script&lang=ts"
import style0 from "./HomeHorizontal.vue?vue&type=style&index=0&id=239c811e&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c811e",
  null
  
)

export default component.exports